import { If } from '@finn/design-system/atoms/If';
import { useMediaQuery } from '@finn/design-system/helpers/media';
import Head from 'next/head';

import { HeroType, ResponsiveImageSizes } from '~/types/UIModules';

import { NarrowContent } from './components/NarrowContent';
import HeroContent from './HeroContent';
import { getOptimizedHeroImage } from './utils';

const SecondaryHero = ({ data }) => {
  const { image, ...rest } = data;

  const heroType = rest.level.value;
  const isMd = useMediaQuery('md');
  const isSm = useMediaQuery('sm');

  const responsiveImage = image && {
    sm: getOptimizedHeroImage(image, ResponsiveImageSizes.SMALL),
    md: getOptimizedHeroImage(image, ResponsiveImageSizes.MEDIUM),
    lg: getOptimizedHeroImage(image, ResponsiveImageSizes.LARGE),
  };

  const isTertiaryHero = heroType === HeroType.tertiary;
  const imgSrc = responsiveImage[isSm ? 'sm' : isMd ? 'md' : 'lg']?.url;
  const hasImages = Boolean(!isTertiaryHero && responsiveImage);

  return (
    <>
      <If condition={hasImages}>
        <Head>
          <link
            rel="preload"
            href={responsiveImage.sm?.url}
            as="image"
            media={`(max-width: ${responsiveImage.sm?.width}px)`}
          />
          <link
            rel="preload"
            href={responsiveImage.md?.url}
            as="image"
            media={`(max-width: ${responsiveImage.md?.width}px)`}
          />
          <link
            rel="preload"
            href={responsiveImage.lg?.url}
            as="image"
            media={`(max-width: ${responsiveImage.lg?.width}px)`}
          />
        </Head>
      </If>

      <If condition={isTertiaryHero}>
        <div className="container">
          <HeroContent
            title={rest.title}
            subtitle={rest.subtitle}
            heroType={heroType}
            cta={rest.cta}
            guideMetaData={rest.guide_meta_data?.metadata}
            label={rest.label}
            noImage={isTertiaryHero || !responsiveImage}
            secondaryCta={rest.secondary_cta}
          />
        </div>
      </If>

      <If condition={!isTertiaryHero}>
        <NarrowContent
          title={rest.title}
          subtitle={rest.subtitle}
          guideMetaData={rest.guide_meta_data?.metadata}
          src={imgSrc}
          cta={rest.cta}
          secondaryCta={rest.secondary_cta}
        />
      </If>
    </>
  );
};

export default SecondaryHero;
